import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PlusSvg = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.5293 10.5884L17.6469 10.5884",
                stroke: "#7C7B7B",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.5884 3.5293L10.5884 17.6469",
                stroke: "#7C7B7B",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
export default PlusSvg;
